import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase.js';
import { useState, useEffect } from 'react';


import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


// a drop down menu with the name and image of a dish
// when expanded shows the ingredients, extras and notes of the dish
export default function ReviewDishCard({dishInfo}) {

  //get ingredients list
  let ings = [];
  dishInfo["ingredients"].map((i) => {
    ings.push(" " + i.name);
  });
  if (ings.length > 0) {
    ings = "Ingredients: " + ings;
  }


  //extras list
  let ext = [];
  for (const [k, value] of Object.entries(dishInfo.extras)) {
    ext.push(" " + value.quantity + "x " + value.name + "  (+$" + (value.cost * value.quantity) + ")");
  };
  if (ext.length > 0) {
    ext = "Extras: " + ext;
  }


  //calculate final price of dish
  let finalPrice = dishInfo.final_price * dishInfo.quantity;
  
  //get special instructions if there are any
  let specialInstructions = "";
  if (dishInfo.customerInstructions != "") {
    specialInstructions = "Special instructions: " + dishInfo.customerInstructions;
  }


  const fetchImageUrl = async (path) => {
    const storageRef = ref(storage, path);
  
    try {
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error("Error fetching image URL:", error);
      return null;
    }
  };

  const [dishImage, setDishImage] = useState("");
  useEffect(() => {
    const get_dish_image = async () => {
      const url = await fetchImageUrl(dishInfo.imagePath);
      setDishImage(url);
    };

    get_dish_image();
  }, [])

  return (
    <Accordion sx={{mb: 1, width: 1}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx = {{
            m: 'none',
          }}
        >
          <CardMedia
            component="img"
            sx = {{
              display: { xs: 'none', sm: 'block' },
              width: 100,
              minWidth: 100,
              height: 100,
            }}
            image={dishImage}
            alt={"picture of " + dishInfo.name}
          />
          <Box sx = {{
              display: 'flex',
              flexDirection: {xs: 'row', sm: 'column'},
              alignItems: {xs: 'center', sm: 'start'},
            }}>
            <Typography gutterBottom variant="subtitle1" component="div" padding={1}>
              {dishInfo.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" padding={1}>
              ${finalPrice}
            </Typography>
          </Box>
          
        </AccordionSummary>
        <AccordionDetails>
        <Typography gutterBottom variant="subtitle1" component="div">
          {ings}
        </Typography>
        <Typography gutterBottom variant="subtitle1" component="div">
          {ext}
        </Typography>
        <Typography gutterBottom variant="subtitle1" component="div">
          {specialInstructions}
        </Typography>
        </AccordionDetails>
      </Accordion>
  );
}